import { getIsAuthenticated, getIsAuthenticating, getIsNotAuthenticated } from 'dux/auth/selectors';
import { fetchFeatureFlags } from './actions';

export const fetchFeatureFlagsOnAuthSuccess = store => next => action => {
  const wasAuthenticating = getIsAuthenticating(store.getState());
  const wasAuthenticated = getIsAuthenticated(store.getState());
  const result = next(action);
  const isDoneAuthenticating = !getIsAuthenticating(store.getState());
  const isNotAuthenticated = getIsNotAuthenticated(store.getState());

  // Refetch flags on log-in because user context changed so flag rules might have changed
  if (wasAuthenticating && isDoneAuthenticating) {
    fetchFeatureFlags()(store.dispatch, store.getState);
  }
  // Refetch flags on log-out because user context changed so flag rules might have changed
  if (wasAuthenticated && isNotAuthenticated) {
    fetchFeatureFlags()(store.dispatch, store.getState);
  }
  return result;
};
